// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"53941afd","39":"ac9cb3bc","43":"e8836379","408":"2fe15995","414":"aea8e023","453":"3bc7c597"}[chunkId] + ".chunk.js";
};